// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../../common/JQueryView';

export default class GrantorInformationView extends JQueryView {
  constructor() {
    super('.change-owners-wrapper');
  }

  @on({ event: 'input', selector: '.positive-integer' })
  acceptOnlyPositiveInteger(e: any) {
    const target = $(e.target);
    target.val(target.val().replace(/[^0-9]/g, ''));
  }
}
